module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAAAAAA6fptVAAAACklEQVR4nGMyBgAAOQA2uj8QjAAAAABJRU5ErkJggg=="